<template>
  <div class="monitorAcceptance-main">
    <div class="monitorAcceptance_content flex">
      <div class="content_center flexColumn"
        style="width:100%;height: 100%;padding: 10px;justify-content: space-between;">
        <div class="flex" style="height: 55.5%;justify-content: space-between;">
          <div style="width:24%;height: 100%;" class="flexColumn">
            <div class="content_style" style="height:45%">
              <div class="style_title">
                {{ titleMenuList[0] }}
              </div>
              <div class="style_content">
                <div style="height: calc(100% - 0px);width:100%">
                  <v-chart ref="echarts1" theme="macarons" style="width: 100%;height: 100%;"
                    :options="todayOption"></v-chart>
                </div>
              </div>
            </div>
            <div class="content_style" style="height:54%">
              <div class="style_title">
                {{ titleMenuList[1] }}
              </div>
              <div class="style_content" style="height: calc(100% - 69px);">
                <v-chart ref="echarts2" theme="macarons" style="width: 100%;height: 100%;"
                  :options="apartmentRate"></v-chart>
              </div>
            </div>
          </div>
          <div style="height: 100%;width: 50%;" class="flexColumn">
            <div class="flex menuL" style="
                height: 40px;
                line-height: 40px;
                margin-bottom: 2px;
                justify-content: space-between !important;
                white-space: nowrap;
              ">
              <div class="flex" style="justify-content: flex-start">
                <div v-for="(item, index) in menuList" class="menuStyle SYHT-Bold" style="margin-right: 10px" :key="index"
                  :class="{ isActive: item.is }" @click="skip(item)">
                  {{ item.mtma03 }}
                </div>
              </div>
            </div>
            <div style="height: calc(100% - 40px); width: 100%" v-if="menuList.length">
              <video v-if="menuList.filter((el) => el.is)[0].mtma04 == '1'" :src="$store.state.baseUrl +
                menuList.filter((el) => el.is)[0].mtma05
                " id="videoPath" ref="audio" poster="../../../assets/img/ycy-cy-3.png" autoplay loop muted
                controls="fasle" style="width: 100%; height: 100%; object-fit: unset"></video>
              <img v-else-if="menuList.filter((el) => el.is)[0].mtma04 == '2'" :src="$store.state.baseUrl +
                menuList.filter((el) => el.is)[0].mtma05
                " style="width: 100%; height: 100%" alt />
              <BimModel v-else style="width: 100%; height: 100%; position: relative"
                :url="menuList.filter((el) => el.is)"></BimModel>
            </div>
            <div v-else style="height: calc(100% - 40px);width:100%">
              <video :src="menuList.filter((el) => el.is)[0].videoPath" id="videoPath"
                v-if="menuList.filter((el) => el.is).length ? menuList.filter((el) => el.is)[0].type == 'mp4' : ''"
                ref="audio" poster="../../../assets/img/ycy-cy-3.png" autoplay loop muted controls="fasle"
                style="width: 100%;height: 100%;object-fit: unset;"></video>
              <BimModel v-else style="width: 100%;height:100%;position: relative;" url="/UploadFiles/Company/场地布置/3d.svf">
              </BimModel>
            </div>
          </div>
          <div style="width:24%;height: 100%;" class="flexColumn">
            <div class="content_style" style="height:44%">
              <div class="style_title">
                {{ titleMenuList[4] }}
              </div>
              <div class="style_content flex">
                <el-image :src="require('../../../assets/img/Intelligence/组 20 1.png')"
                  @click.native="imageClick1('left')" class="left-img1"></el-image>
                <div class="swiper1">
                  <el-carousel style="width: 100%;height:100%" trigger="click" :autoplay="true" ref="cardShow1"
                    arrow="always">
                    <el-carousel-item style="font-size:16px" v-for="item in chartList_R_1" :key="item.cmtb01">
                      <div class="carousek">
                        <div class="carousel_Title flex">
                          <div class="fzfs">{{ TableListHead_5[0] }}：</div>
                          <el-tooltip class="item" effect="dark" :content="item.cmtb05" placement="top">
                            <div class="fzfs font_col2">{{ item.cmtb05 }}</div>
                          </el-tooltip>
                        </div>
                        <div class="carousel_content flex" style="justify-content: flex-start;">
                          <img src="../../../assets/img/Intelligence/Vector.png" alt="" />
                          <div class="content_mian">
                            <div class="flex"
                              style="height:50%;justify-content: space-between;border-bottom: 1px dashed #fff;">
                              <div>
                                <span class="fzfs">{{ TableListHead_5[1] }}：</span>
                                <el-tooltip class="item" effect="dark" :content="item.cmtb06" placement="top">
                                  <span class="fzfs font_col2" style="margin-left:5px">{{ item.cmtb06 }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <span class="fzfs">{{ TableListHead_5[2] }}：</span>
                                <el-tooltip class="item" effect="dark" :content="item.cmtb07" placement="top">
                                  <span class="fzfs font_col2" style="margin-left:5px">{{ item.cmtb07 }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <span class="fzfs">{{ TableListHead_5[3] }}：</span>
                                <el-tooltip class="item" effect="dark" :content="item.cmtb08" placement="top">
                                  <span class="fzfs font_col2" style="margin-left:5px">{{ item.cmtb08 }}</span>
                                </el-tooltip>
                              </div>
                            </div>
                            <div class="flex" style="height:50%;margin-top: 1px;justify-content: flex-start">
                              <div>
                                <span class="fzfs">{{ TableListHead_5[4] }}：</span>
                                <el-tooltip class="item" effect="dark" :content="item.cmtb09" placement="top">
                                  <span class="fzfs font_col2" style="margin-left:5px">{{ item.cmtb09 }}</span>
                                </el-tooltip>
                              </div>
                              <div style="margin-left:20px">
                                <span class="fzfs">{{ TableListHead_5[5] }}：</span>
                                <el-tooltip class="item" effect="dark" :content="item.cmtb10" placement="top">
                                  <span class="fzfs font_col2" style="margin-left:5px">{{ item.cmtb10 }}</span>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <el-image :src="require('../../../assets/img/Intelligence/组 20 2.png')"
                  @click.native="imageClick1('right')" class="right-img1"></el-image>
              </div>
            </div>
            <div class="content_style" style="height:55%">
              <div class="style_title">
                {{ titleMenuList[5] }}
              </div>
              <div class="style_content" style="height: calc(100% - 69px);">
                <div class="flex attendance">
                  <!-- <div class="attendanceImg">
                    <div style="margin-top: 8px;">
                      <span>已完成：75.00%</span>
                    </div>
                  </div>
                  <div class="attendanceImg">
                    <div style="margin-top: 8px;">
                      <span>未完成：25.00%</span>
                    </div>
                  </div> -->
                </div>
                <div class="flex todayAttendanceTU" style="height: 100%;">
                  <div id="todayAttendance" style="width: 100%;height:100%;"></div>
                  <img class="todayAttendanceBJ" src="../../../assets/img/Wisdom/attendanceBtom.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height:44%;width: 100%;justify-content: space-between;" class="flex">
          <div style="height:100%;width: 75%;">
            <div class="content_style" style="height:100%">
              <div class="style_title2">
                {{ titleMenuList[2] }}
              </div>
              <div class="style_content ">
                <el-row style="width:100%;height: 100%;" :gutter="24">
                  <el-col style="height: 100%;" :span="15" :offset="0">
                    <div style="width:100%;height: 11%;">
                      <el-select style="width:12%;" v-model="value" placeholder="请选择" size="mini" @change="(v) => {
                        options1 = zTreeList.filter((el) => el.trdt05 == v);
                        options2 = [];
                        options3 = [];
                        options4 = [];
                        value1 = '';
                        value2 = '';
                        value3 = '';
                        value4 = '';
                        lfifItem2 = {};
                        lfifItem = {};
                        tableList = [];
                      }
                        ">
                        <el-option v-for="item in zTreeList.filter(
                          (el) => el.trdt05 == 0
                        )" :key="item.trdt01" :label="item.trdt04" :value="item.trdt01">
                        </el-option>
                      </el-select>
                      <el-select style="width:12%;margin: 0px 10px;" v-model="value1" placeholder="请选择" @change="(v) => {
                        options2 = zTreeList.filter((el) => el.trdt05 == v);
                        GetIfinfo(v);
                        options3 = [];
                        options4 = [];
                        value2 = '';
                        value3 = '';
                        value4 = '';
                        lfifItem2 = {};
                        tableList = [];
                      }
                        " size="mini">
                        <el-option v-for="item in options1" :key="item.trdt01" :label="item.trdt04" :value="item.trdt01">
                        </el-option>
                      </el-select>
                      <el-select style="width:12%;" v-model="value2" placeholder="请选择" @change="(v) => {
                        options3 = zTreeList.filter((el) => el.trdt05 == v);
                        value3 = '';
                        value4 = '';
                        options4 = [];
                        lfifItem2 = {};
                        tableList = [];
                      }
                        " size="mini">
                        <el-option v-for="item in options2" :key="item.trdt01" :label="item.trdt04" :value="item.trdt01">
                        </el-option>
                      </el-select>
                      <el-select style="width:12%;margin: 0px 10px;" v-model="value3" placeholder="请选择" @change="(v) => {
                        options4 = zTreeList.filter((el) => el.trdt05 == v);
                        GetIfinfo(v, 2);
                        value4 = '';
                        lfifItem2 = {};
                        tableList = [];
                      }
                        " size="mini">
                        <el-option v-for="item in options3" :key="item.trdt01" :label="item.trdt04" :value="item.trdt01">
                        </el-option>
                      </el-select>
                      <el-select style="width:12%;" @change="(v) => {
                        GetWallNumber(v);
                      }
                        " v-model="value4" placeholder="请选择" size="mini">
                        <el-option v-for="item in options4" :key="item.trdt01" :label="item.trdt04" :value="item.trdt01">
                        </el-option>
                      </el-select>
                    </div>
                    <el-row style="height:90%" :gutter="24">
                      <el-col style="height:100%" :span="12" :offset="0">
                        <img style="height:100%;width:100%;" v-if="lfifItem.lfif03"
                          :src="$store.state.baseUrl + lfifItem.lfif03" alt="" />
                      </el-col>
                      <el-col style="height:100%" :span="2" :offset="0">
                      </el-col>
                      <el-col style="height:100%" :span="10" :offset="0">
                        <div class="flex" style="width:100%;height:100%;margin-right: 2%;">
                          <el-image :src="require('../../../assets/img/Intelligence/组 20 1.png')
                            " @click.native="imageClick('left')" class="left-img"></el-image>
                          <div class="swiper" style="position: relative;">
                            <el-carousel style="width: 100%;height:100%" trigger="click" :autoplay="true" ref="cardShow"
                              arrow="always" indicator-position="none">
                              <el-carousel-item style="font-size:16px">
                                <div style="width:100%;height:200px;text-align:center;">
                                  <img style="width:100%;height:100%" :src="$store.state.baseUrl + lfifItem2.lfif03
                                    " alt="" />
                                  <div style="position: absolute;left: 43%;bottom: 16%;" v-if="zTreeList.filter(
                                    (el) => el.trdt01 == value3
                                  ).length
                                    ">
                                    {{
                                      zTreeList.filter(
                                        (el) => el.trdt01 == value3
                                      )[0].trdt04
                                    }}
                                  </div>
                                </div>
                              </el-carousel-item>
                            </el-carousel>
                          </div>
                          <el-image :src="require('../../../assets/img/Intelligence/组 20 2.png')
                              " @click.native="imageClick('right')" class="right-img"></el-image>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col style="height: 100%;
                    overflow: auto;" :span="9" :offset="0">
                    <el-table :data="tableList" highlight-current-row  height="100%" :header-cell-style="{
                      background: '#053e72',
                      color: '#85c6f0',
                      textAlign: 'center',
                    }" style="width: 100%;" :show-header="false" :cell-style="{ textAlign: 'center' }">
                      <el-table-column class="roww" v-for="(item, index) in transTitle" :key="index"
                        style="background-image:none" align="center" >
                        <template slot-scope="scope">
                          <el-tooltip class="item" effect="dark" :content="scope.row[index]" placement="top">
                            <div style="height:20px" class="textEllipsis">
                              {{ scope.row[index] }}
                            </div>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- <ul
                      style="height:15%;margin:2% 0"
                      class="UlStyle"
                      :gutter="24"
                    >
                      <li
                        class="itemLiStyle flex"
                        style="height:100%;justify-content: flex-start;"
                        v-for="(item, index) in tableList"
                        :key="index"
                      >
                        <div class="tdStyle" v-for="v in item">{{ v }}</div>
                      </li>
                    </ul> -->
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div style="height:100%;width:24%;">
            <div class="content_style" style="height:100%">
              <div class="style_title">
                {{ titleMenuList[6] }}
              </div>
              <div class="style_content">
                <el-table :data="chartList_R_3" highlight-current-row height="100%" :header-cell-style="{
                  background: '#053e72',
                  color: '#85c6f0',
                  textAlign: 'center',
                }" :cell-style="{ textAlign: 'center' }">
                  <el-table-column prop="date" align="center" label="发布时间">
                    <template slot="header" slot-scope="scope">
                      <span>{{ TableListHead_8[0] }}</span>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.cmtb05 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" align="center">
                    <template slot="header" slot-scope="scope">
                      <span>{{ TableListHead_8[1] }}</span>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.cmtb06 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value" align="center" label="">
                    <template slot="header" slot-scope="scope">
                      <span>{{ TableListHead_8[2] }}</span>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.cmtb07 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="user" align="center" label="" width="80">
                    <template slot="header" slot-scope="scope">
                      <span>{{ TableListHead_8[3] }}</span>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.cmtb08 }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import * as echarts from "echarts";
import BimModel from "../bimViewModelIfram.vue";
import { color } from "highcharts";
import {
  GetTitleSet,
  GetCustomTable,
  GetChartsData,
  GetMultimedia,
  GetWallNumber,
  GetProjectModelList,
  GetIfinfo,
  GetTreeData,
} from "@/setAxios.js";
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
  name: "monitorAcceptance",
  components: { BimModel },
  data() {
    return {
      todayOption: {},
      dataList: [
        { value: 40, name: "运行" },
        { value: 38, name: "充电" },
        { value: 32, name: "待机" },
      ],
      option: {},
      data: [
        { value: 480, name: "碰撞故障" },
        { value: 455, name: "电机故障" },
        { value: 400, name: "电池故障" },
        { value: 354, name: "激光故障" },
        { value: 300, name: "倾角故障" },
      ],
      //各楼栋实测/复测合格率
      apartmentRate: {
        color: ["#1E84FF", "#60D7A7"],
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: (params) => {
            var res = `${params[0].name} : ${params[0].value} <br/>`;
            return res;
          },
        },
        //图例
        legend: {
          //   icon: "circle", //形状
          itemHeight: 10,
          right: 10,
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          //线轴 虚线
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
          data: [],
        },
        yAxis: {
          name: "数值",
          type: "value",
          // 轴线
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          axisLabel: {
            color: "#01A1E5",
          },
          //线轴 虚线
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#143662",
            },
          },
          // 刻度
          axisTick: {
            show: false,
          },
          splitArea: {
            show: false,
          },
        },
        series: [
          {
            name: "实测",
            data: [30, 45, 60, 30, 115, 40, 90],
            type: "line",
            symbol: "none", //去掉线上的圆点
            showSymbol: false,
            smooth: true, //是否平滑曲线
            areaStyle: {
              color: "#1E84FF", //阴影区域
              opacity: 0.2,
            },
          },
          {
            name: "复测",
            data: [0, 60, 30, 90, 45, 60, 30, 60],
            type: "line",
            symbol: "none", //去掉线上的圆点
            smooth: true, //是否平滑曲线
            showSymbol: false,
            areaStyle: {
              color: "#60D7A7", //阴影区域
              opacity: 0.2,
            },
          },
        ],
        grid: {
          left: "12%",
          right: "10%",
          top: "18%",
          bottom: "12%",
        },
      },
      mileageOption: {},
      mileageList: [
        { value: 480, name: "4/12" },
        { value: 455, name: "4/13" },
        { value: 400, name: "4/14" },
        { value: 354, name: "4/15" },
        { value: 300, name: "4/16" },
        { value: 350, name: "4/17" },
        { value: 380, name: "4/18" },
        { value: 390, name: "4/19" },
      ],
      menuList: [
        {
          name: "智能装备概况",
          is: true,
          type: "mp4",
          videoPath: "./video/项目之窗.mp4",
        },
        {
          name: "专项数字建造监控",
          type: "model",
          is: false,
          videoPath: "./video/项目之窗.mp4",
        },
      ],
      tableData: [
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "进场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "进场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "进场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "出场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "进场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "出场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "进场",
        },
        {
          time: "2023/04/23 11:24:41",
          sb: "AQI",
          name: "周泽南",
          status: "出场",
        },
      ],
      options: [],
      value: "",
      options1: [],
      value1: "",
      options2: [],
      options3: [],
      options4: [],
      value2: "",
      value3: "",
      value4: "",
      titledate: [
        "测量时间",
        "墙面平整度",
        "墙面垂直度",
        "阴阳角方正",
        "顶板平整度",
        "墙面面积",
        "爆点统计",
      ],
      tableList: [],
      transTitle: [],
      LTlist: [],
      TableListHead_2: [],
      TableListHead_5: [],
      TableListHead_8: [],
      chartList_L_2: [],
      chartList_R_1: [],
      chartList_R_2: [],
      chartList_R_3: [],
      zTreeList: [],
      titleMenuList: [],
      lfifItem: {},
      lfifItem2: {},
    };
  },
  mounted() {
    // this.uploadAndownLoadMonth();
    window.addEventListener('resize', () => {
      this.$refs.echarts1.resize()
      this.$refs.echarts2.resize()
    })
  },
  created() {
    this.todayEvent();
    this.GetTitleSet();
    this.GetCustomTable(11);
    this.GetCustomTable(12);
    this.GetChartsData(26);
    this.GetChartsData(25);
    this.GetChartsData(27);
    this.GetTreeData();
    this.GetMultimedia();
  },
  methods: {
    GetWallNumber(id) {
      let params = {
        treeid: id,
        pageIndex: 1,
        pageSize: 999,
      };
      GetWallNumber({ params }).then((res) => {
        this.tableList = res.Data.list;
        this.init();
      });
    },
    GetIfinfo(id, type) {
      let params = {
        treeid: id,
      };
      GetIfinfo({ params }).then((res) => {
        if (type) {
          this.lfifItem2 = res.Data;
        } else {
          this.lfifItem = res.Data;
        }
      });
    },
    GetTitleSet() {
      GetTitleSet({
        params: {
          xid: this.$store.state.xid,
          name: "",
        },
      }).then((res) => {
        this.titleMenuList = [
          "智能装备状态监测",
          "各楼栋实测/复测合格率",
          "自动测量点位分析及结果",
          "中间多媒体",
          "智能装备参数",
          "实测任务占比",
          "智能装备使用记录",
        ];
        this.TableListHead_2 = [
          "实测",
          "复测",
        ];
        this.TableListHead_5 = [
          "设备编号",
          "设备状态",
          "运行速度",
          "核心温度",
          "累计充电次数",
          "电机转速",
        ];
        this.TableListHead_8 = ["时间", "操作设备", "操作人员", "进出场"];
        if (res.Data.length > 0) {
          res.Data.forEach((el) => {
            if (el.tist03 == "检测与验收类模块") {
              this.titleMenuList[Number(el.tist04) - 1] = el.tist05;
            } else if (el.tist03 == "检测与验收类第二模块") {
              this.TableListHead_2[Number(el.tist04) - 2] = el.tist05;
            } else if (el.tist03 == "检测与验收类第五模块") {
              this.TableListHead_5[Number(el.tist04) - 1] = el.tist05;
            } else if (el.tist03 == "检测与验收类第八模块") {
              this.TableListHead_8[Number(el.tist04) - 1] = el.tist05;
            }
          });
        }
      });
    },
    GetCustomTable(index) {
      GetCustomTable({
        params: {
          xid: this.$store.state.xid,
          cmtb03: index,
          searchword: "",
          pageSize: 999,
          pageIndex: 1,
        },
      }).then((res) => {
        if (index == 11) {
          this.chartList_R_1 = res.Data.list;
        } else {
          this.chartList_R_3 = res.Data.list;
        }
      });
    },
    GetChartsData(index) {
      GetChartsData({
        params: {
          xid: this.$store.state.xid,
          csdt03: index,
          searchword: "",
          pageSize: 999,
          pageIndex: 1,
        },
      }).then((res) => {
        if (index == 26) {
          this.chartList_L_2 = res.Data.list.filter((el) => el.csdt04 != 1);
          let arrUnit = [];
          arrUnit = res.Data.list.filter((el) => el.csdt04 == 1);
          this.apartmentRate.xAxis.data = this.chartList_L_2.map(
            (el) => el.csdt05
          );

          this.apartmentRate.xAxis.name = arrUnit[0] ? arrUnit[0].csdt05 : '';
          this.apartmentRate.yAxis.name = arrUnit[0] ? arrUnit[0].csdt06 : '';
          this.apartmentRate.tooltip = {
            show: true,
            trigger: "axis",
            formatter: (params) => {
              var res = `${params[0].name} : ${this.TableListHead_2[0]} ${params[0].value} ${this.apartmentRate.yAxis.name}<br/> \n ${params[1].name} : ${this.TableListHead_2[1]} ${params[1].value} ${this.apartmentRate.yAxis.name}<br/>`;
              return res;
            },
          }
          this.apartmentRate.series = [
            {
              name: this.TableListHead_2[0],
              data: this.chartList_L_2.map((el) => el.csdt06),
              type: "line",
              symbol: "none", //去掉线上的圆点
              showSymbol: false,
              smooth: true, //是否平滑曲线
              areaStyle: {
                color: "#1E84FF", //阴影区域
                opacity: 0.2,
              },
            },
            {
              name: this.TableListHead_2[1],
              data: this.chartList_L_2.map((el) => el.csdt07),
              type: "line",
              symbol: "none", //去掉线上的圆点
              smooth: true, //是否平滑曲线
              showSymbol: false,
              areaStyle: {
                color: "#60D7A7", //阴影区域
                opacity: 0.2,
              },
            },
          ];
        } else if (index == 25) {
          let _this = this;
          //csdt04 ==2 先过滤 csdt04 ==1 为单位
          if (res.Data.list.length > 0) {
            let arr = res.Data.list.filter((el) => {
              if (el.csdt04 == 2) {
                return el;
              }
            });
            this.dataList = arr.map((el) => {
              return { value: Number(el.csdt06), name: el.csdt05 };
            });
          } else {
            this.dataList = [
              { value: 50, name: "已完成" },
              { value: 49, name: "未完成" },
            ];
          }

          this.todayOption = {
            color: ["#43A5FF", "#FDDF00", "#03F3F8"],
            legend: {
              right: "40",
              top: "40",
              icon: "circle",
              textStyle: {
                color: "rgb(255,255,255,0.9)",
              },
              orient: "vertical",
            },
            tooltip: {
              trigger: "item",
            },
            toolbox: {
              show: true,
            },
            series: [
              {
                name: "Access From",
                type: "pie",
                radius: ["45%", "50%"],
                center: ["35%", "50%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      position: "outside",
                      color: color[i],
                      formatter: function (params) {
                        var percent = 0;
                        var total = 0;
                        for (var i = 0; i < _this.dataList.length; i++) {
                          total += _this.dataList[i].value;
                        }
                        percent = ((params.value / total) * 100).toFixed(0);
                        if (params.name !== "") {
                          return "" + params.name + "\r\r" + percent + "%";
                        } else {
                          return "";
                        }
                      },
                    },
                    labelLine: {
                      length: 30,
                      length2: 10,
                      show: true,
                      color: "#00ffff",
                    },
                  },
                },
                labelLine: {
                  length: 10,
                },
                tooltip: {
                  show: false,
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 15,
                    fontWeight: "bold",
                  },
                },
                data: (function () {
                  let arr = [];
                  let colorList = ["#43A5FF", "#FDDF00", "#03F3F8"];
                  _this.dataList.forEach((el) => {
                    arr.push({
                      value: el.value,
                      name: el.name,
                      itemStyle: {
                        normal: {
                          borderWidth: 5,
                          shadowBlur: 10,
                          // borderColor: "rgba(255,255,255,0.1)",
                          // shadowColor: colorList[i],
                          shadowColor: "#fff",
                        },
                      },
                    });
                  });
                  return arr;
                })(),
              },
              {
                name: "2",
                type: "pie",
                radius: ["38%", "40%"],
                center: ["35%", "50%"],
                avoidLabelOverlap: false,
                labelLine: {
                  length: 20,
                },
                label: {
                  show: false,
                  position: "center",
                },
                tooltip: {
                  show: false,
                },
                emphasis: {
                  disable: false,
                  scale: false, //扇区是否缩放
                  scaleSize: 0,
                  // label: {
                  //   show: false,
                  //   fontSize: 0,
                  //   fontWeight: "bold",
                  // },
                },
                itemStyle: {
                  normal: {
                    color: function (colors) {
                      var colorList = [
                        "#D1BB09",
                        "#D1BB09",
                        "#D1BB09",
                        "#D1BB09",
                      ];
                      return colorList[colors.dataIndex];
                    },
                    borderRadius: "50%",
                    borderWidth: 10,
                  },
                },
                data: [
                  { value: 1, name: "" },
                  { value: 1, name: "" },
                  { value: 1, name: "" },
                  { value: 1, name: "" },
                ],
              },
            ],
          };
        } else {
          this.chartList_R_2 = res.Data.list.map((el) => {
            return { name: el.csdt05, y: Number(el.csdt06), sliced: true };
          });
          this.TodayAttendance();
        }
      });
    },
    GetTreeData() {
      GetTreeData({ params: { xid: this.$store.state.xid, trdt03: 2 } }).then(
        (res) => {
          if (res.Data.length) {
            this.zTreeList = res.Data;
            this.value = res.Data[0].trdt01;
            this.options1 = this.zTreeList.filter(
              (el) => el.trdt05 == this.value
            );
            this.value1 = this.options1[0].trdt01;
            this.GetIfinfo(this.value1);
            this.options2 = this.zTreeList.filter(
              (el) => el.trdt05 == this.value1
            );
            this.value2 = this.options2[0].trdt01;
            this.options3 = this.zTreeList.filter(
              (el) => el.trdt05 == this.value2
            );
            this.value3 = this.options3[0].trdt01;
            this.GetIfinfo(this.value3, 2);
            this.options4 = this.zTreeList.filter(
              (el) => el.trdt05 == this.value3
            );
            this.value4 = this.options4[0].trdt01;
            this.GetWallNumber(this.value4);
          }
        }
      );
    },
    skip(item) {
      this.menuList.forEach((el) => {
        el.mtma01 != item.mtma01 ? (el.is = false) : (el.is = true);
      });
    },
    // 多媒体
    async GetMultimedia() {
      let params = {
        xid: localStorage.xid,
        mtma09: 6,
      };
      let res = await GetMultimedia({ params });
      if (res.Data) {
        this.menuList = res.Data.map((v) => {
          return {
            ...v,
            is: false,
          };
        });
        // 给下标为0的对象is变为TRUE
        for (const key in this.menuList) {
          if (key == 0) {
            this.menuList[0].is = true;
          }
        }
      } else {
        this.menuList;
      }
    },
    todayEvent() {
      let _this = this;
      this.option = {
        color: ["#39D3F9", "#5366F6", "#80D5EC", "#F2993D", "#358AFF"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: "20",
          top: "20",
          textStyle: {
            color: "#c3c3c3",
          },
          formatter: function (name) {
            let data = _this.data;
            let total = 0;
            let tarValue;
            for (let i = 0; i < data.length; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                tarValue = data[i].value;
              }
            }
            let v = tarValue + "人";
            //计算出百分比
            let p = Math.round((tarValue / total) * 100) + "%";
            return `${name}   ${p}`;
            //name是名称，v是数值
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "60%",
            center: ["25%", "50%"],
            roseType: "radius",
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            data: this.data,
            itemStyle: {
              // 类型之间设置白空隙
              normal: {
                borderWidth: 4,
                borderColor: "#ffffff",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.mileageOption = {
        title: {
          text: "",
        },
        grid: {
          top: "10%",
          left: "0%",
          bottom: "0%",
          right: "0%",
          containLabel: true,
        },
        tooltip: {
          show: true,
        },
        // animation: false,
        xAxis: [
          {
            type: "category",
            data: _this.mileageList.map((item) => {
              return item.name;
            }),
            axisLine: {
              lineStyle: {
                color: "rgb(47, 60, 80)",
              },
            },
            // 刻度
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#82b0ec",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: "12",
              },
              margin: 20,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgb(13, 114, 208)",
              },
            },
            splitArea: { show: false }, //去除网格区域
            splitLine: { show: false },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgb(13, 114, 208)",
              },
            },
            // 刻度
            axisTick: {
              show: false,
            },
            //线轴 虚线
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                opacity: 0.2,
              },
            },
          },
        ],
        series: [
          // 顶部
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, -6],
            symbolPosition: "end",
            z: 12,
            label: {
              normal: {
                show: false,
                position: "top",
                // "formatter": "{c}%"
                fontSize: 18,
                fontWeight: "bold",
                color: "#16E0FF",
              },
            },
            color: "#16E0FF",
            data: _this.mileageList.map((item) => {
              return item.value;
            }),
          },
          {
            name: "",
            type: "pictorialBar", //底部
            symbolSize: [20, 10],
            symbolOffset: [0, 0],
            z: 12,
            color: "#103E81",
            data: _this.mileageList.map((item) => {
              return item.value;
            }),
          },
          {
            type: "bar",
            barWidth: "20",
            barGap: "10%", // Make series be overlap
            barCateGoryGap: "10%",
            symbolOffset: [0, -1],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
                  {
                    offset: 0,
                    color: "#00B7FE",
                  },
                  {
                    offset: 0.5,
                    color: "#0D579A",
                  },
                  {
                    offset: 1,
                    color: "#123160",
                  },
                ]),
                opacity: 0.8,
              },
            },
            data: _this.mileageList.map((item) => {
              return item.value;
            }),
          },
        ],
      };
    },
    //   var chartDom = document.getElementById("uploadAndownLoadMonth");
    //   var myChart = echarts.init(chartDom);
    //   var option;
    //   let lineData = [];
    //   for (var i = 1; i <= 12; i++) {
    //     lineData.push(i + "月");
    //   }
    //   option = {
    //     ///backgroundColor: "#0f375f",
    //     grid: {
    //       x: 30,
    //       y: 10,
    //       x2: 5,
    //       y2: 20,
    //       borderWidth: 1,
    //     },
    //     tooltip: {
    //       trigger: "axis",
    //       axisPointer: {
    //         type: "shadow",
    //       },
    //       formatter: (params) => {
    //         var res = `${params[0].name} <br/>`;
    //         for (const item of params) {
    //           if (item.seriesName !== "") {
    //             res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} ：${item.value}<br/>`;
    //           }
    //         }
    //         return res;
    //       },
    //     },
    //     color: ["rgb(31,148,242)"],
    //     xAxis: {
    //       data: lineData,
    //       axisLine: {
    //         lineStyle: {
    //           color: "rgb(47, 60, 80)",
    //         },
    //       },
    //       // 刻度
    //       axisTick: {
    //         show: false,
    //       },
    //       axisLabel: {
    //         textStyle: {
    //           color: "#ccc",
    //         },
    //       },
    //     },
    //     yAxis: {
    //       type: "value",
    //       splitLine: { show: false },
    //       axisLine: {
    //         show: false,
    //         lineStyle: {
    //           color: "rgb(13, 114, 208)",
    //         },
    //       },
    //       // 刻度
    //       axisTick: {
    //         show: false,
    //       },
    //       //线轴 虚线
    //       splitLine: {
    //         show: true,
    //         lineStyle: {
    //           type: "dashed",
    //           opacity: 0.2,
    //         },
    //       },
    //     },
    //     series: [
    //       {
    //         name: "离职人数",
    //         type: "bar",
    //         barWidth: 7,
    //         itemStyle: {
    //           borderRadius: 5,
    //           normal: {
    //             //柱形图圆角，初始化效果
    //             barBorderRadius: [55, 55, 55, 55],
    //           },
    //           color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
    //             { offset: 1, color: "rgb(59, 204, 243)" },
    //             { offset: 0, color: "rgb(34, 148, 241)" },
    //           ]),
    //         },
    //         data: [155, 185, 255, 245, 485, 412, 375, 165, 266, 225, 316, 123],
    //       },
    //       {
    //         name: "",
    //         type: "bar",
    //         barGap: "-100%",
    //         barWidth: 8,
    //         itemStyle: {
    //           normal: {
    //             //柱形图圆角，初始化效果
    //             barBorderRadius: [55, 55, 55, 55],
    //             color: "rgb(10, 34, 66)",
    //             borderColor: "rgb(22,61,109)",
    //           },
    //         },
    //         z: -12,
    //         data: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500],
    //       },
    //     ],
    //   };

    //   option && myChart.setOption(option);
    // },
    TodayAttendance() {
      let _this = this;
      // 图表初始化函数
      var chart = Highcharts.chart("todayAttendance", {
        chart: {
          type: "pie", //指定图表的类型
          options3d: {
            enabled: true,
            alpha: 70, //X轴-3d偏转角度：倾斜角度
            beta: 0,
          },
          backgroundColor: "rgba(255,255,255,0)",
        },
        credits: { enabled: false }, //关闭官网链接标识
        title: {
          text: "", // 标题
        },
        legend: {
          // enabled: true, //不显示图例
          layout: "vertical", //图例布局：竖直方向排列
          backgroundColor: "rgba(255,255,255,0)", //图例背景颜色
          borderRadius: "5", //图例背景边框圆角
          maxHeight: 200, // 最大高度
          lineHeight: 200, // 行高
          padding: 0, //内边距
          itemMarginTop: 20, //图例每行举上高度
          squareSymbol: true,
          x: 0, //x,y设置图例位置
          y: 0,
          align: "right", //居左显示
          itemStyle: {
            //字体颜色
            color: "#fff",
          },
          verticalAlign: "middle", //图例框的垂直对齐
          //保留小数点1位
          labelFormatter: function () {
            return (
              this.name +
              "<b>&nbsp;&nbsp;&nbsp;&nbsp;" +
              this.percentage.toFixed(2) +
              "%</b>"
            );
          },
        },
        //显示的内容
        tooltip: {
          headerFormat: "{series.name}<br>",
          pointFormat: "{point.name}: <b>{point.percentage:.2f}%</b>", ///小数点保留位
        },
        /*
        在 3D 饼图中，chart.depth 对饼图是不起作用的，
        只有设置在 plotOptions.pie.depth 里的才有效
        */
        plotOptions: {
          pie: {
            innerSize: 0, //设置圆环
            allowPointSelect: true,
            cursor: "pointer",
            startAngle: 150, //图填充的开始角度
            slicedOffset: 20, // 突出间距
            size: 200, // 设置饼图大小
            depth: 20,
            dataLabels: {
              enabled: true, //去掉图例的数据标签
              style: {
                // fontSize: "16px",
                textOutline: "none", //黑色文本轮廓
              },
              formatter: function () {
                return (
                  '<p style="color:' +
                  this.color +
                  '">' +
                  this.point.name +
                  '</p><br><p style="color:' +
                  this.color +
                  '">' +
                  this.percentage.toFixed(2) +
                  "%</p>"
                );
              }, //图例数据颜色跟图例颜色一致
            },
            opacity: 1, //透明度
            colors: ["#00A8FF", "#00D7E9"],
            showInLegend: false, // 显示在图例中
          },
        }, // 针对特定图表类型生效的 3D 配置
        series: [
          {
            type: "pie",
            name: "",
            tooltip: {
              trigger: "item",
            },
            data: _this.chartList_R_2,
          },
        ],
      });
    },

    imageClick(val) {
      let _this = this;
      if (val == "right") {
        //点击右按钮切换至下一页走马灯
        this.$refs.cardShow.next();
        let index = this.options3.findIndex(
          (el, index) => el.trdt01 == _this.value3
        );
        _this.value3 = this.options3[index + 1]
          ? this.options3[index + 1].trdt01
          : this.options3[0].trdt01;
      } else {
        //点击左按钮切换至上一页走马灯
        this.$refs.cardShow.prev();
        let index = this.options3.findIndex(
          (el, index) => el.trdt01 == _this.value3
        );
        _this.value3 = this.options3[index - 1]
          ? this.options3[index - 1].trdt01
          : this.options3[this.options3.lastIndex].trdt01;
      }
      _this.GetIfinfo(_this.value3, 2);
      this.options4 = this.zTreeList.filter((el) => el.trdt05 == this.value3);
      this.value4 = this.options4[0].trdt01;
      this.GetWallNumber(this.value4);
    },
    imageClick1(val) {
      if (val == "right") {
        //点击右按钮切换至下一页走马灯
        this.$refs.cardShow1.next();
      } else {
        //点击左按钮切换至上一页走马灯
        this.$refs.cardShow1.prev();
      }
    },
    init() {
      let aa = [
        {
          wlnb03: "2023/05/1616:43:15",
          wlnb04: "1F-002R-东",
          wlnb05: "1",
          wlnb06: "1",
          wlnb07: "1",
          wlnb08: "2",
          wlnb09: "2",
          wlnb10: "2",
        },
      ];
      if (this.tableList.length > 0) {
        let matrixData = this.tableList.map((row) => {
          let arr = [];
          for (let key in row) {
            // 按表头的顺序 一个一个加入进去 示例表格展示有顺序要求 不能改变位置 所以取到数据一一对应
            // 如果没有顺序要求 或者后端返回的数据没问题 直接push 不需要判断  arr.push(row[key])
            if (key == "wlnb03") {
              arr[0] = row[key];
            } else if (key == "wlnb04") {
              arr[1] = row[key];
            } else if (key == "wlnb05") {
              arr[2] = row[key];
            } else if (key == "wlnb06") {
              arr[3] = row[key];
            } else if (key == "wlnb07") {
              arr[4] = row[key];
            } else if (key == "wlnb08") {
              arr[5] = row[key];
            } else if (key == "wlnb09") {
              arr[6] = row[key];
            } else if (key == "wlnb10") {
              arr[7] = row[key];
            }
          }
          return arr;
        });

        // 加入标题拼接最终的数据
        if (matrixData.length > 0) {
          this.tableList = matrixData[0].map((col, i) => {
            return [
              this.titledate[i],
              ...matrixData.map((row) => {
                return row[i]; //因为数据多出一行，需要从索引1开始
              }),
            ];
          });
          // 横向展示序号
          this.transTitle = matrixData.map((col, i) => {
            return [i + 1];
          });
          this.transTitle.unshift("");
        }
      }
    },
  },
};
</script>
<style lang="less">
.monitorAcceptance-main {
  .el-table__body {
    border-collapse: separate;
    border-spacing: 0px;
  }

  width: 100%;
  height: calc(100% - 10px);
  padding-top: 10px;

  .monitorAcceptance_content {
    width: 100%;
    height: 100%;

    .content_left {
      width: 24%;
      height: 100%;
    }
  }

  .flex {
    width: 100%;
  }

  .menuStyle {
    background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    padding: 0px 40px;
    box-sizing: content-box;
    width: 14%;
    height: 100%;
    color: #fff;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .isActive {
    background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
  }

  .content_style {
    width: 100%;
    height: 33%;

    .style_title {
      background-image: url("../../../assets/img/Wisdom/Group 3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 14px;
      padding: 10px 25px;
      font-weight: bold;
      color: #fff;
    }

    .style_content {
      border-bottom: 2px solid #074b7c;
      height: calc(100% - 74px);
      margin-top: 10px;
      background-color: rgba(0, 99, 187, 0.15);
      width: calc(100% -20px);
      padding: 10px;
      color: #fff;

      .bj_1 {
        background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        text-align: center;
        font-weight: bold;
        width: 40%;
        height: 30%;
      }

      .bj_2 {
        background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 10% center;
        text-align: center;
        font-weight: bold;
        padding: 8px;
        letter-spacing: 5px;
        font-size: 20px;
        text-align: center;
        color: #04e8f8;
        font-family: "fzfs" !important;
      }

      .tian {
        position: relative;

        &::after {
          position: absolute;
          content: "天";
          right: -30%;
          color: #fff;
          bottom: 2px;
        }
      }
    }
  }

  .style_title2 {
    background-image: url("../../../assets/img/Wisdom/Group23.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-family: "fzfs";
    font-size: 14px;
    padding: 10px 25px;
    font-weight: bold;
    color: #fff;
  }

  .attendance {
    margin: 0px auto;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    width: 86%;

    .attendanceImg {
      color: rgb(118, 223, 241);
      font-size: 14px;
      background-image: url("../../../assets/img/Wisdom/attendance.png");
      width: 126px;
      height: 33px;
      text-align: center;
    }
  }

  .todayAttendanceTU {
    margin-top: -35px;
  }

  .todayAttendanceBJ {
    width: 280px;
    height: 105px;
    position: absolute;
    margin-top: 30px;
  }

  .el-input__inner {
    background-color: #051735;
    border: 1px solid #048b9f;
  }

  //去除整体背景色
  .el-table,
  .el-table__expanded-cell {
    background-color: transparent !important;
    color: #3c9def;
  }

  .el-table::before {
    //去除底部白线
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 0px !important;
  }

  //修改行内线
  .el-table td,
  .building-top .el-table th.is-leaf,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid transparent;
  }

  //修改高度
  ::v-deep .el-table .cell {
    line-height: 20px;
    margin-left: 15px;
  }

  .el-table .el-table__cell.gutter {
    background-color: #053e72 !important;
  }

  // .el-table__row:nth-of-type(1) {
  //   background-image: none !important;
  //   background-color: red !important;
  // }
  //修改行背景
  .el-table .el-table__row {
    background-image: url("../../../assets/img/Wisdom/Group\ 307.png");
    background-repeat: no-repeat;
    background-size: 100% 80%;
    background-position: center;
    background-color: transparent !important;

    &:nth-child(1) {
      background-image: none;
      background-color: #043d6e !important;
    }

    // &:nth-child(2) {
    //   background-image: none;
    //   background-color: #043d6e !important;
    // }
  }

  /* 用来设置当前页面element全局table 选中某行时的背景色*/
  .el-table__body tr.current-row>td {
    background-color: transparent !important;
  }

  .el-table__body tr.current-row {
    background-image: url("../../../assets/img/Wisdom/Group\ 327.png");
    background-repeat: no-repeat;
    background-size: 100% 80%;
    background-position: center;
  }

  //鼠标悬停
  .el-table tbody tr:hover>td {
    background-color: #44525f !important;
    color: #fff;
  }

  // 走马灯--图标改变
  .left-img {
    top: 95px;
    left: 70px;
    cursor: pointer;
    z-index: 3;
  }

  .right-img {
    top: 95px;
    right: 80px;
    cursor: pointer;
    z-index: 2;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .el-carousel__container {
    height: 100%;
  }

  .el-carousel__arrow--left,
  .el-carousel__arrow--right {
    display: none;
  }

  // 走马灯--图标改变
  .swiper1 {
    width: 80%;
    height: 100%;
  }

  .el-carousel__container {
    height: 100%;
  }

  .left-img1 {
    margin-right: 5px;
    cursor: pointer;
  }

  .right-img1 {
    margin-left: 5px;
    cursor: pointer;
  }

  .el-carousel__item {
    width: 100%;

    .carousek {
      width: 100%;

      .carousel_Title {
        width: 100%;
        height: 40px;
        margin-top: 10px;
        font-size: 15px;
        justify-content: flex-start;
        padding-left: 10px;
        background-image: url("../../../assets/img/Intelligence/Group\ 2091.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 设置背景图片的位置以及重复方式 */
        background-position: center top;
      }

      .carousel_content {
        height: 55%;
        margin-top: 10px;

        .content_mian {
          width: 80%;
          height: 70%;
          margin-left: 10px;
          font-size: 12px;
        }
      }
    }
  }

  .UlStyle {
    .itemLiStyle {
      background-image: url("../../../assets/img/Wisdom/Group\ 307.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;

      .tdStyle {
        width: 300px;
      }
    }

    .itemLiStyle:nth-of-type(1),
    .itemLiStyle:nth-of-type(2) {
      background-image: none;
      background-color: #053e72;
    }
  }

  .font_col2 {
    margin-left: 10px;
    color: #4edce1;
  }
}
</style>
